import { Pipe, PipeTransform } from '@angular/core';

import { StructureDto, StructureRassRecherche } from '../../models/structure-dto.model';

@Pipe({
  name: 'structureRaisonIdNat'
})
export class StructureRaisonIdNatPipe implements PipeTransform {

  /**
   * Format an object StructureDTO to `Raison_Sociale - idNatStructure`
   * @param structure Struture
   * @param withRaisonSociale Display raison sociale of a structure
   * @returns `Raison_Sociale - idNatStructure` or undefined
   */
  transform(structure: StructureDto | StructureRassRecherche, withRaisonSociale = true): string {
    return (structure?.raisonSociale && structure?.typeStructure && structure?.idStructure)
      ? (withRaisonSociale)
      ? `${structure?.raisonSociale} - ${structure?.typeStructure}${structure?.idStructure}`
      : `${structure?.typeStructure}${structure?.idStructure}`
      : undefined;
  }

}
